<style lang="scss" scoped>
.login{
    width: 100%;
    height: 100%;
    background: #f3f3f3;
    .login-content{
        width: 400px;
        background: #fff;
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 0 40px #d9d9d9;
    }
    .login-left{
        padding: 0 20px;
        height: 100px;
        background: #1D9EDA;
    }
    .login-right{
        padding: 0 20px 20px;
        .custom-input{   
            background: none;
            border-radius: 0;
            border: none;
            border-bottom: 1px solid #f4fbff;
            height: 40px;
            width: 100%;
            font-size: 16px;
            >input{
                height: 40px;
            }
            .login-right__code{
                width: 100px;
                height: 40px;
            }
        }
        .login-right__btn{
            width: 100%;
        }
    }
}
</style>

<template>
    <div class="login flex-row-center">
        <div class="login-content">
            <div class="login-left flex-row-center">
                <img src="@/assets/images/logo.png" />
            </div>
            <div class="login-right">
                <div class="text-white">登录/LOGIN</div>
                <input 
                    class="MT-20 MB-20 
                    custom-input" 
                    placeholder="请输入账号" 
                    v-model="accout"/>
                <input 
                    class="custom-input MB-20" 
                    type="password" 
                    placeholder="请输入密码" 
                    v-model="password"
                    @keydown.enter="loginHandler"/>
                <el-select  class="custom-input MB-20"  v-model="company" placeholder="请选择">
                    <el-option
                    v-for="item in companyList"
                    :key="item.companyId"
                    :label="item.name"
                    :value="item.companyId">
                    </el-option>
                </el-select>    
                <!-- <div class="flex-row-start custom-input">
                    <input 
                        type="text" 
                        class="text-16 flex-w__1" 
                        placeholder="请输入验证码"
                        v-model="code">
                    <div class="login-right__code flex-row-center" @click="refreshCode">
                        <img :src="API_URL+'/login/code'" v-if="refresh"/>
                    </div>
                </div> -->
                <el-button 
                    class="login-right__btn MT-20 text-18" 
                    round 
                    type="primary"
                    @click="loginHandler">
                    登录
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import config from '@/config/index.js'
export default {
    data() {
        return {
            // 接口地址
            API_URL: config.API,
            // 是否刷新
            refresh: true,
            // 登录账号
            accout: '',
            // 登录密码
            password: '',
            // 登录验证码
            code: '',
            //公司列表
            company:"",
            companyList:[]
        }
    },
    created() {
    },
    mounted(){
        this.getCompanyList()
    },
    methods: {
        /**
         * 刷新验证码
         */
        refreshCode() {
            this.refresh = false
            setTimeout(() => {
                this.refresh = true
            })
        },
        /**
         * 登录函数
         */
        loginHandler() {
            if (!this.accout) {
                this.$message.error('请输入登录账号');
                return
            }
            if (!this.password) {
                this.$message.error('请输入登录密码');
                return
            }
                  
            this.$ajax(config.EXTERNAL_API + '/login/doLogin', {
                username: this.accout,
                password: this.password,
                // code: this.code,
                companyId:this.company,
            },{
                replaceHeaders:true,
                n_authorization:true,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                }
            }).then(async (data) => {
                this.$message.success('登录成功')
                this.$store.commit('setUserInfo',data.data)

                let menuList = await this.getUserMenus()
                // sessionStorage.setItem("menuList",menuList)
                this.$store.commit('setMenuList',menuList)
                this.$router.replace({
                    path: '/'
                })
            }).catch(() => {
                this.refreshCode()
            })

        },
        /**
         * 获取公司列表
         */
        getCompanyList() {
            this.$ajax(config.EXTERNAL_API + '/user/getCompanyList', {
            },{
                n_authorization:true,
                method: "get"
            }).then((data) => {
                let companyList = data.data.companyList || []
                this.companyList = companyList
                if(companyList.length){
                    this.company = companyList[0].companyId
                }
            })
        },

        /**
         * 获取用户菜单
         */
        async getUserMenus(load = true){
            let menuList = []
            await this.$ajax(
                config.EXTERNAL_API+ `/user/getUserMenus/DATA_CENTER`,
                {},
                {
                load,
                method:"get"
                },
            ).then(data => {
                menuList = data.data.menus
            });

            return menuList
        },
    }
}
</script>

